export default "__VITE_ASSET__5a44cd8f__"